import React from 'react';
import moment from 'moment';
import { injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { useIntl } from 'react-intl';
import RenterBillingInformation from './RenterBillingInformation.js';
import OwnerBillingInformation from './OwnerBillingInformation.js';
import CurrencyConverter from '../../../CurrencyConverter/CurrencyConverter';
import { getFixedValue } from '../../../../helpers/currencyConvertion';
import ToolTipSection from '../../../Common/ToolTipSection/ToolTipSection.js';
import { getPromoCodeDetailsValue } from '../../../../helpers/GetDynamicItemName/dynamicHomeValue.js';

//Styles
import cs from '../../../../components/commonStyle.css';
import s from '../ViewReservation.css';
import messages from '../../../../locale/jsonMessages';

const BillingInformation = ({ data }) => {
    const { formatMessage, locale } = useIntl();
    let isSpecialPricingAssigned, isAverage = 0, dayDifference = data?.dayDifference, dayPrice = 0;
    let guestTotal = 0, hostTotal = 0, isDayTotal = 0, refundToGuest = 0, refundCurrency, payoutToHost = 0, payoutCurrency;
    isSpecialPricingAssigned = data?.bookingSpecialPricing?.length > 0 ? true : false, hostTotal;

    if (isSpecialPricingAssigned) {
        data?.bookingSpecialPricing?.map((item, index) => {
            dayPrice = dayPrice + Number(item?.isSpecialPrice);
        });
    } else {
        dayPrice = data?.basePrice * dayDifference;
    }
    if (data?.promoCodeType == "admin") {
        hostTotal = (data?.total + data?.promoDiscount) - data?.hostServiceFee;
    } else {
        hostTotal = data?.total - data?.hostServiceFee;
    }

    guestTotal = data?.total + data?.guestServiceFee + data?.securityDeposit;

    isAverage = getFixedValue(Number(dayPrice) / Number(dayDifference));
    isDayTotal = isAverage * dayDifference;
    dayPrice = isDayTotal;

    if (data?.cancellationDetails) {
        refundToGuest = data?.cancellationDetails?.refundToGuest;
        payoutToHost = data?.cancellationDetails?.payoutToHost;
        payoutCurrency = data?.cancellationDetails?.currency;
        refundCurrency = data?.cancellationDetails?.currency;
    } else if (data) {
        payoutToHost = hostTotal;
        payoutCurrency = data?.currency;
        refundCurrency = data?.currency;
        if (!data?.cancellationDetails && (data?.reservationState == 'expired' || data?.reservationState == 'declined')) {
            refundToGuest = guestTotal;
        }
    }

    const promoCodeDetails = JSON.parse(data?.dynamicPromoCodeDetails || '[]');
    const dynamicValue = getPromoCodeDetailsValue(promoCodeDetails, locale);

    const pricingInformation = () => {
        return (
            <div className={cx(cs.displayFlex, cs.alignCenter, cs.gap4)}>
                {
                    isSpecialPricingAssigned &&
                    <ToolTipSection label={formatMessage(messages.averageRate)} />
                }
                <div className={cx(cs.displayFlex, cs.alignCenter, cs.gap4)}>
                    <CurrencyConverter
                        amount={dayPrice}
                        from={data?.currency}
                    />
                    <div className={cx(s.secondaryTextColor, cs.displayFlex, cs.gap4)}>
                        (<CurrencyConverter
                            amount={isAverage}
                            from={data?.currency}
                        />
                        <span>{'x'}</span>
                        <span>{dayDifference}</span>
                        <span>{formatMessage({ id: dayDifference > 1 ? 'nights' : 'night' })}</span>)
                    </div>
                </div>
            </div>
        )
    }

    const couponCodeInform = () => {
        return (
            <>
                <div className={cx(cs.displayFlex, cs.alignCenter, cs.gap4)}>
                    <ToolTipSection label={dynamicValue.description ? dynamicValue.description : data?.promoCodeDescription} />
                    {data?.promoCode}
                </div>
                <div className='secondaryText'>
                    {data?.promoCodeType === 'admin' ?
                        <span className={cs.displayInlineBlock}>({formatMessage(messages.payByAdmin)})</span> :
                        <span className={cs.displayInlineBlock}>({formatMessage(messages.payByHost)})</span>
                    }
                </div>
            </>
        )
    }

    return (
        <div>
            <RenterBillingInformation
                deliveryPrice={data?.delivery || 0}
                convertCurrency={data?.currency}
                discount={data?.discount || 0}
                discountType={data?.discountType}
                serviceFee={data?.guestServiceFee}
                securityDeposit={data?.securityDeposit}
                total={guestTotal}
                serviceFeeType={data?.guestServiceFeeType}
                serviceFeeValue={data?.guestServiceFeeValue}
                pricingData={pricingInformation}
                refundCurrency={refundCurrency}
                refundToGuest={refundToGuest}
                claimRefund={data?.claimRefund}
                promoCode={couponCodeInform()}
                promoDiscount={data?.promoDiscount}
                dynamicPromoCodeDetails={data?.dynamicPromoCodeDetails}

            />
            <OwnerBillingInformation
                deliveryPrice={data?.delivery || 0}
                convertCurrency={data?.currency}
                discount={data?.discount || 0}
                discountType={data?.discountType}
                serviceFee={data?.hostServiceFee}
                securityDeposit={data?.securityDeposit}
                total={hostTotal}
                serviceFeeType={data?.hostServiceFeeType}
                serviceFeeValue={data?.hostServiceFeeValue}
                pricingData={pricingInformation}
                payoutCurrency={payoutCurrency}
                payoutToHost={payoutToHost}
                claimPayout={data?.claimPayout}
                promoCode={couponCodeInform()}
                promoDiscount={data?.promoDiscount}
                promoCodeType={data?.promoCodeType}
            />
        </div>
    )
}

export default injectIntl(withStyles(cs, s)(BillingInformation));
